const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i

/**
 * Notification ids are UUIDs. An id reaches a request path from a URL
 * parameter and from the service worker, so anything else is refused: `read-all#`
 * or `../../v2/auth/logout#` would otherwise steer the POST elsewhere.
 */
export function isNotificationId(value: unknown): value is string {
  return typeof value === 'string' && UUID.test(value)
}
